/* ==========================================================================
   Varlo | UTM Capture (v4.0 — HubSpot)
   - Stores FIRST and LAST touch (cookie + localStorage, 30d)
   - Replays UTM params onto the current URL so HubSpot's native
     query-string population fills hidden form fields (no DOM injection)
   - Click IDs (gclid/fbclid/msclkid) are STORED but never replayed,
     so stale ad clicks can't re-seed Google's attribution cookies
   - No link decoration (kept GA4 sessions clean)
   - No Hulk field-fill (HubSpot renders cross-origin; unreachable anyway)

   Debug in console:  VARLO_UTM.getLast()  /  .getFirst()  /  .clear()
   ========================================================================== */
(function () {
  if (window.__VARLO_UTM_CAPTURE_LOADED__) return;
  window.__VARLO_UTM_CAPTURE_LOADED__ = true;

  var COOKIE_DAYS = 30;
  var COOKIE_NAME_FIRST = 'varlo_utm_first';
  var COOKIE_NAME_LAST  = 'varlo_utm_last';
  var COOKIE_NAME_LAND  = 'varlo_first_landing';

  // Everything we store on the visitor
  var TRACK_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_adgroup',
    'utm_term', 'utm_content',
    'gclid', 'msclkid', 'fbclid'
  ];

  // Only these get written back onto the URL. Click IDs are deliberately
  // excluded: replaying a gclid from a click weeks ago would let gtag mint
  // a fresh _gcl_aw cookie and misattribute the conversion.
  var REPLAY_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_adgroup',
    'utm_term', 'utm_content'
  ];

  // Never run on checkout — Shopify owns those URLs.
  if ((location.pathname || '').indexOf('/checkout') === 0) return;

  /* ---------- helpers ---------- */

  function nowISO() { return new Date().toISOString(); }

  function getDomain(ref) {
    try { return (new URL(ref)).hostname; } catch (e) { return ''; }
  }

  function getParamMap() {
    var out = {};
    try {
      var params = new URLSearchParams(location.search);
      params.forEach(function (v, k) { out[k.toLowerCase()] = v; });
    } catch (e) {}
    return out;
  }

  function hasTrackingParams(map) {
    return TRACK_KEYS.some(function (k) { return !!map[k]; });
  }

  function setCookie(name, value, days) {
    try {
      var expires = '';
      if (days) {
        var d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + d.toUTCString();
      }
      var secure = (location.protocol === 'https:') ? '; Secure' : '';
      document.cookie = name + '=' + encodeURIComponent(value) +
        expires + '; path=/; SameSite=Lax' + secure;
    } catch (e) {}
  }

  function getCookie(name) {
    try {
      var esc = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
      var m = document.cookie.match(new RegExp('(?:^|; )' + esc + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  function saveStorage(key, obj) {
    var json = JSON.stringify(obj || {});
    try { localStorage.setItem(key, json); } catch (e) {}
    setCookie(key, json, COOKIE_DAYS);
  }

  function loadStorage(key) {
    var s = null;
    try { s = localStorage.getItem(key); } catch (e) {}
    if (s) { try { return JSON.parse(s); } catch (e) {} }
    var c = getCookie(key);
    if (c) { try { return JSON.parse(c); } catch (e) {} }
    return null;
  }

  // Builds a touch record. Every tracked key is written explicitly — including
  // empty ones — so a new campaign visit CLEARS the previous campaign's values
  // instead of leaving stale ones behind.
  function buildTouch(params) {
    var touch = {
      page_url: location.href,
      page_title: document.title,
      referrer: document.referrer || '',
      referrer_domain: getDomain(document.referrer || ''),
      landing_page: getCookie(COOKIE_NAME_LAND) || location.href,
      timestamp: nowISO()
    };
    TRACK_KEYS.forEach(function (k) { touch[k] = params[k] || ''; });
    return touch;
  }

  /* ---------- capture ---------- */

  var params = getParamMap();
  var trackingPresent = hasTrackingParams(params);

  if (!getCookie(COOKIE_NAME_LAND)) {
    setCookie(COOKIE_NAME_LAND, location.href, COOKIE_DAYS);
  }

  // First touch: written once, never overwritten while it persists.
  if (!loadStorage(COOKIE_NAME_FIRST)) {
    saveStorage(COOKIE_NAME_FIRST, buildTouch(params));
  }

  // Last touch: overwritten on any visit carrying tracking params.
  var lastTouch = loadStorage(COOKIE_NAME_LAST);
  if (trackingPresent || !lastTouch || !lastTouch.timestamp) {
    lastTouch = buildTouch(params);
    saveStorage(COOKIE_NAME_LAST, lastTouch);
  }

  /* ---------- replay onto URL (this is what HubSpot reads) ---------- */

  try {
    var url = new URL(location.href);
    var sp = url.searchParams;
    var alreadyPresent = REPLAY_KEYS.some(function (k) { return sp.has(k); });

    if (!alreadyPresent) {
      var stored = loadStorage(COOKIE_NAME_LAST) || {};
      var added = false;
      REPLAY_KEYS.forEach(function (k) {
        if (stored[k]) { sp.set(k, stored[k]); added = true; }
      });
      if (added) history.replaceState(null, '', url.toString());
    }
  } catch (e) {}

  /* ---------- debug ---------- */

  try {
    window.VARLO_UTM = {
      getFirst: function () { return loadStorage(COOKIE_NAME_FIRST); },
      getLast:  function () { return loadStorage(COOKIE_NAME_LAST); },
      clear: function () {
        try { localStorage.removeItem(COOKIE_NAME_FIRST); } catch (e) {}
        try { localStorage.removeItem(COOKIE_NAME_LAST); } catch (e) {}
        setCookie(COOKIE_NAME_FIRST, '', -1);
        setCookie(COOKIE_NAME_LAST, '', -1);
        setCookie(COOKIE_NAME_LAND, '', -1);
        return 'cleared';
      }
    };
  } catch (e) {}
})();